import React, { useState, useEffect } from "react";
import retirementIcon from "../../../assets/social-security-icons/fra-earnings.svg";
import { ToolTipCreator } from "../../../helpers/ToolTipCreator";
import barIcon from "../../../assets/social-security-icons/barChartRet.svg";
import compareIcon from "../../../assets/social-security-icons/compare-age.svg";
import benefitIcon from "../../../assets/social-security-icons/benefit-decrease-without-rfa.svg";
import lifetimeIcon from "../../../assets/social-security-icons/lifetime-benefit.svg";
import timeIcon from "../../../assets/social-security-icons/ageCompare.svg";
import { HorizontalBar, Line } from "react-chartjs-2";
import { SocialSecurityFormFields } from "./SocialSecurityFormFields";
import { MODULE_API } from "../../../apis";
import "../styles/socialSecurity.css";
import { SocialSecurityHardCodeFields } from "./SocialSecurityHardCodeFields";
import { calculateSocialSecurityResults } from "../../../helpers/socialSecurityCalculations";
import {
  compareFRAandChosenAge,
  generateLineChartData,
  calculateRetirementAnalysis,
} from "../../../helpers/retirementCalculator";
import { formatCurrencyAmount } from "../../../helpers/formatAmount";
import { SocialSecurityFormSkeleton } from "../../InsuranceNew/InsuraceDashboardComponents/SocialSecurityFormSkeleton";
import NewLoader from "../../../components/styled-components/loader/NewLoader";
import { NumberCardSkeleton } from "../../Skeletons/DebtSkeleton";
import moment from "moment";

export const RetirementCalculator = () => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState(null);
  const [analysisFormData, setAnalysisFormData] = useState(null);
  const [results, setResults] = useState(null);
  const [analysisResults, setAnalysisResults] = useState(null);
  const [userEntryResults, setUserEntryResults] = useState(null);
  const [socialFieldsData, setSocialFieldsData] = useState(null);

  const [loadingAttributesRetirement, setLoadingAttributesRetirement] =
    useState(false);
  const [retirementAttributes, setRetirementAttributes] = useState(null);

  const [loadingAttributesAnalysis, setLoadingAttributesAnalysis] =
    useState(false);
  const [analysisAttributes, setAnalysisAttributes] = useState(null);

  const moduleRetirement = "Retirement Earnings Test Calculator";
  const moduleBreakAnalysis = "Break-even Analysis";

  const moduleDataToFetch = "Social Security Calculator";

  const handleChange = (name, value) => {
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleAnalysisChange = (name, value) => {
    setAnalysisFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const formFields = [
    {
      label: "Enter date you would like to begin receiving benefits",
      type: "date",
      name: "benefitStartDate",
    },
    {
      label: "Your Estimated Earnings",
      type: "number",
      name: "estimatedEarnings",
    },
    {
      label:
        "Monthly Decrease In Benefit (Retiring early, not same year as FRA)",
      type: "number",
      name: "monthlyDecreaseSame",
    },
    {
      label: "Monthly Decrease In Benefit (Retiring early, same year as FRA)",
      type: "number",
      name: "monthlyDecreaseNotSame",
    },
    {
      label:
        "Check here if you had years of active military service after 1956",
      type: "radio",
      name: "military",
      options: [
        { label: "Yes", value: true },
        { label: "No", value: false },
      ],
    },
  ];
  const analysisFormFields = [
    {
      label: "First Claiming Age",
      type: "number",
      name: "ageAtFRA",
    },
    {
      label: "Second Claiming Age",
      type: "number",
      name: "ageSocialSecurity",
    },
  ];
  const resultArray = [
    {
      id: 1,
      name: "Monthly Decrease in Benefit (Retiring early, not same year as FRA)",
      icon: benefitIcon,
      value:
        results && results.monthlyAtFRA
          ? formatCurrencyAmount(results.monthlyAtFRA)
          : "$0.00",
    },
    {
      id: 2,
      name: "Monthly Decrease in Benefit (Retiring early, same year as FRA)",
      icon: benefitIcon,
      value:
        results && results.monthlyAtClaim
          ? formatCurrencyAmount(results.monthlyAtClaim)
          : "$0.00",
    },
  ];

  const analysisResultArray = [
    {
      id: 2,
      name: `Claiming at Age ${
        (analysisResults && analysisResults.firstClaimAge) || ""
      }`,
      icon: lifetimeIcon,
      value:
        analysisResults && analysisResults.earlyLifetime
          ? formatCurrencyAmount(analysisResults.earlyLifetime)
          : "$0.00",
    },
    {
      id: 3,
      name: `Claiming at Age ${
        (analysisResults && analysisResults.secondClaimAge) || ""
      }`,
      icon: lifetimeIcon,
      value:
        analysisResults && analysisResults.laterLifetime
          ? formatCurrencyAmount(analysisResults.laterLifetime)
          : "$0.00",
    },
    // {
    //   id: 4,
    //   name: "Life Expectancy Used",
    //   icon: lifetimeIcon,
    //   value: analysisResults && analysisResults.lifeExpectancy &&analysisResults.lifeExpectancy || "N/A",
    // },
  ];
  const lineChartData = {
    labels: [
      "Age 62",
      "Age 63",
      "Age 64",
      "Age 65",
      "Age 66",
      "Age 67",
      "Age 68",
      "Age 69",
      "Age 70",
    ], // example
    datasets: [
      {
        label: "Average User at FRA (~70)",
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0], // replace with your mean FRA data
        borderColor: "#C9D5F1",
        backgroundColor: "#C9D5F1",
        // fill: true,
        // tension: 0.3,
      },
      {
        label: `User at Age ${
          (formData && formData["Second Claiming Age"]) || 65
        }`,
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0], // replace with calculated results
        borderColor: "#2A3DA3",
        backgroundColor: "#2A3DA3",
        // fill: true,
        // tension: 0.3,
      },
    ],
  };
  const lineChartOptions = {
    responsive: true,
    legend: {
      position: "bottom",
    },
    scales: {
      yAxes: [
        {
          beginAtZero: true,
          gridLines: {
            color: "rgba(0, 0, 0, 0)",
          },
          ticks: {
            callback: function (value) {
              return new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }).format(value);
            },
          },
        },
      ],
      xAxes: [
        {
          gridLines: {
            color: "rgba(0, 0, 0, 0)",
          },
          title: { display: true, text: "Age" },
        },
      ],
    },
  };

  const barChartData = {
    labels: ["Break-even Analysis"],
    datasets: [
      {
        label: `First Claiming Age ${
          analysisResults && analysisResults.firstClaimAge
            ? analysisResults.firstClaimAge
            : "0"
        } years`,
        data:
          analysisResults && analysisResults.earlyLifetime
            ? [Number(analysisResults.earlyLifetime.toFixed(2))]
            : [0],
        backgroundColor: ["#C9D5F1"],
      },
      {
        label: `Second Claiming Age ${
          analysisResults && analysisResults.secondClaimAge
            ? analysisResults.secondClaimAge
            : "0"
        } years`,
        data:
          analysisResults && analysisResults.laterLifetime
            ? [Number(analysisResults.laterLifetime.toFixed(2))]
            : [0],
        backgroundColor: ["#2A3DA3"],
      },
    ],
  };
  const options = {
    plugins: {
      datalabels: {
        display: false, // We’ll handle the text rendering manually
      },
    },
    legend: {
      position: "bottom",
    },
    maintainAspectRatio: false,
    responsive: true,
    scales: {
      xAxes: [
        {
          stacked: false, // Ensure bars are stacked on the x-axis (horizontal stacking)
          gridLines: {
            color: "rgba(0, 0, 0, 0)", // Make grid lines invisible
          },
          ticks: {
            beginAtZero: true,
            callback: function (value) {
              // Format the ticks on the x-axis as currency
              return new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }).format(value);
            },
          },
        },
      ],
      yAxes: [
        {
          stacked: false, // Stack bars vertically
          categoryPercentage: 0.5, // Reduce to decrease spacing
          barPercentage: 1,
          ticks: {
            display: false, // Hide y-axis labels
          },
        },
      ],
    },
    tooltips: {
      callbacks: {
        label: (tooltipItem, data) => {
          let label = data.datasets[tooltipItem.datasetIndex].label || "";
          let value =
            data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];

          return `${label}: $${parseFloat(value).toFixed(2)}`;
        },
      },
    },
    animation: {
      onComplete: function () {
        const chart = this.chart;
        const ctx = chart.ctx;
        const datasets = chart.data.datasets;
        datasets.forEach((dataset, index) => {
          ctx.fillStyle = "white"; // Text color
          ctx.textAlign = "center";
          ctx.textBaseline = "middle";

          dataset.data.forEach((value, i) => {
            const x = chart.getDatasetMeta(index).data[i]._model.x;
            const y = chart.getDatasetMeta(index).data[i]._model.y;
            const width = chart.getDatasetMeta(index).data[i]._model.width;
            const height = chart.getDatasetMeta(index).data[i]._model.height;

            // Drawing the value on top of each bar
            ctx.fillText(
              parseFloat(value).toFixed(2), // Value to display
              x + width / 2, // X position (center of the bar)
              y + height / 2 // Y position (center of the bar)
            );
          });
        });
      },
    },
  };

  const handleCalculate = () => {
    if (!formData) return;
    if (formData && formData.id) {
      updateRecord(moduleRetirement, formData);
    } else {
      createAttributes(moduleRetirement, formData);
    }
    const birthdate =
      (socialFieldsData && socialFieldsData["Your Birthdate"]) || null;
    const result = compareFRAandChosenAge({
      estimatedEarnings: Number(formData["Your Estimated Earnings"] || 0),
      benefitStartDate:
        formData["Enter date you would like to begin receiving benefits"] ||
        null,
      birthDate: birthdate,
      military:
        formData[
          "Check here if you had years of active military service after 1956"
        ] || false,
    });

    setResults(result);
  };

  const handleAnalysisCalculate = () => {
    if (!analysisFormData) return;

    if (analysisFormData && analysisFormData.id) {
      updateRecord(moduleBreakAnalysis, analysisFormData);
    } else {
      createAttributes(moduleBreakAnalysis, analysisFormData);
    }

    const FRA_BENEFIT =
      (socialFieldsData &&
        socialFieldsData["Your Monthly Benefit at FRA ($)"]) ||
      0;
    const birthdate =
      (socialFieldsData && socialFieldsData["Your Birthdate"]) || null;
    let currentAge = 0;
    if (birthdate) {
      currentAge = moment().diff(moment(birthdate, "YYYY-MM-DD"), "years");
    }
    const birthYear = moment(birthdate).year();
    const result = calculateRetirementAnalysis({
      fraAmount: FRA_BENEFIT,
      birthDate: birthdate,
      firstClaimAge: Number(analysisFormData["First Claiming Age"] || 65), // “If I take Social Security at FRA”
      secondClaimAge: Number(analysisFormData["Second Claiming Age"] || 70), // “If I take Social Security at (Age)”
      // benefitStartDate:
      //   (formData &&
      //     formData["Enter date you would like to begin receiving benefits"]) ||
      //   null,
      lifeExpectancy:
        (analysisFormData && analysisFormData["Life Expectancy"]) || 0,
      military:
        (formData &&
          formData[
            "Check here if you had years of active military service after 1956"
          ]) ||
        false,
    });
    const lineData = generateLineChartData({
      fraBenefit: FRA_BENEFIT,
      birthYear: birthYear,
      firstClaimAge:
        (analysisFormData && analysisFormData["First Claiming Age"]) || 0,
      secondClaimAge:
        (analysisFormData && analysisFormData["Second Claiming Age"]) || 0,
      lifeExpectancy:
        (analysisFormData && analysisFormData["Life Expectancy"]) || 0,
      military:
        (formData &&
          formData[
            "Check here if you had years of active military service after 1956"
          ]) ||
        false,
    });
    const resultObj = {
      ...result,
      chartData: lineData,
    };
    setAnalysisResults(resultObj);
  };

  console.log("annnnnnn", analysisResults);

  const fetchRetirementModuleData = async (module, socialData) => {
    try {
      setLoading(true);
      const res = await MODULE_API.fetchItems({
        moduleName: module,
        pageNum: 1,
        limit: 10,
        body: {},
      });
      // console.log("resssssss", res);
      if (res && res.records && res.records.length > 0) {
        setFormData(res.records[0]);
        const data = res.records[0];
        const birthdate =
          (socialFieldsData && socialFieldsData["Your Birthdate"]) ||
          (socialData && socialData["Your Birthdate"]) ||
          null;
        const result = compareFRAandChosenAge({
          estimatedEarnings: Number(data["Your Estimated Earnings"] || 0),
          benefitStartDate:
            data["Enter date you would like to begin receiving benefits"] ||
            null,
          birthDate: birthdate,
          military:
            data[
              "Check here if you had years of active military service after 1956"
            ] || false,
        });

        setResults(result);
        return data;
      }
    } catch (error) {
      console.error("Error fetching attributes", error);
    } finally {
      setLoading(false);
    }
  };
  const fetchAnalysisModuleData = async (
    module,
    socialData,
    retirementData
  ) => {
    try {
      setLoading(true);
      const res = await MODULE_API.fetchItems({
        moduleName: module,
        pageNum: 1,
        limit: 10,
        body: {},
      });
      // console.log("resssssss", res);
      if (res && res.records && res.records.length > 0) {
        setAnalysisFormData(res.records[0]);
        const data = res.records[0];

        const FRA_BENEFIT =
          (socialFieldsData &&
            socialFieldsData["Your Monthly Benefit at FRA ($)"]) ||
          (socialData && socialData["Your Monthly Benefit at FRA ($)"]) ||
          0;
        const birthdate =
          (socialFieldsData && socialFieldsData["Your Birthdate"]) ||
          (socialData && socialData["Your Birthdate"]) ||
          null;
        const birthYear = moment(birthdate).year();
        const result = calculateRetirementAnalysis({
          fraAmount: FRA_BENEFIT,
          birthDate: birthdate,
          firstClaimAge: Number(data["First Claiming Age"] || 65), // “If I take Social Security at FRA”
          secondClaimAge: Number(data["Second Claiming Age"] || 70), // “If I take Social Security at (Age)”
          // benefitStartDate:
          //   (formData &&
          //     formData[
          //       "Enter date you would like to begin receiving benefits"
          //     ]) ||
          //   retirementData[
          //     "Enter date you would like to begin receiving benefits"
          //   ] ||
          //   null,
          lifeExpectancy: (data && data["Life Expectancy"]) || 0,
          military:
            (formData &&
              formData[
                "Check here if you had years of active military service after 1956"
              ]) ||
            retirementData[
              "Check here if you had years of active military service after 1956"
            ] ||
            false,
        });
        const lineData = generateLineChartData({
          fraBenefit: FRA_BENEFIT,
          birthYear: birthYear,
          firstClaimAge: (data && data["First Claiming Age"]) || 0,
          secondClaimAge: (data && data["Second Claiming Age"]) || 0,
          lifeExpectancy: (data && data["Life Expectancy"]) || 0,
          military:
            (formData &&
              formData[
                "Check here if you had years of active military service after 1956"
              ]) ||
            retirementData[
              "Check here if you had years of active military service after 1956"
            ] ||
            false,
        });
        const resultObj = {
          ...result,
          chartData: lineData,
        };
        setAnalysisResults(resultObj);
      }
    } catch (error) {
      console.error("Error fetching attributes", error);
    } finally {
      setLoading(false);
    }
  };
  const getRetirementFields = async (Name) => {
    setLoadingAttributesRetirement(true);
    try {
      const res = await MODULE_API.assetFiledDetails(Name);
      if (res && res.attributes) {
        const allAttributes = [...res.attributes];
        const sortedAttributes =
          allAttributes &&
          allAttributes.sort(
            (a, b) => a.groupPriorityValue - b.groupPriorityValue
          );
        setRetirementAttributes(sortedAttributes);
      }
    } finally {
      setLoadingAttributesRetirement(false);
    }
  };
  const getAnalysisFields = async (Name) => {
    setLoadingAttributesAnalysis(true);
    try {
      const res = await MODULE_API.assetFiledDetails(Name);
      if (res && res.attributes) {
        const allAttributes = [...res.attributes];
        const sortedAttributes =
          allAttributes &&
          allAttributes.sort(
            (a, b) => a.groupPriorityValue - b.groupPriorityValue
          );
        setAnalysisAttributes(sortedAttributes);
      }
    } finally {
      setLoadingAttributesAnalysis(false);
    }
  };
  const createAttributes = async (moduleName, data) => {
    try {
      setLoading(true);
      const result = await MODULE_API.addAsset(moduleName, {
        clientModules: [data],
      });
      if (moduleName === "Retirement Earnings Test Calculator") {
        fetchRetirementModuleData(moduleName);
      } else {
        fetchAnalysisModuleData(moduleName);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };
  const updateRecord = async (moduleName, data) => {
    try {
      setLoading(true);
      await MODULE_API.updateClientModule(data.id, {
        ...data,
      });
      if (moduleName === "Retirement Earnings Test Calculator") {
        fetchRetirementModuleData(moduleName);
      } else {
        fetchAnalysisModuleData(moduleName);
      }
      // await fetchModuleData(module);
      setLoading(false);
    } catch (error) {
      console.error("Error updating record", error);
    } finally {
      setLoading(false);
    }
  };
  const fetchData = async () => {
    try {
      setLoading(true);
      const res = await MODULE_API.fetchItems({
        moduleName: moduleDataToFetch,
        pageNum: 1,
        limit: 10,
        body: {},
      });
      // console.log("resssssss", res);
      if (res && res.records && res.records.length > 0) {
        setSocialFieldsData(res.records[0]);
        const data = res.records[0];
        const resultsAll = calculateSocialSecurityResults(res.records[0]);
        // setResults(resultsAll);
        return data;
      }
    } catch (error) {
      console.error("Error fetching attributes", error);
    } finally {
      setLoading(false);
    }
  };
  const fetchAllRetirment = async () => {
    const socialData = await fetchData();
    const retirementData = await fetchRetirementModuleData(
      moduleRetirement,
      socialData
    );
    await fetchAnalysisModuleData(
      moduleBreakAnalysis,
      socialData,
      retirementData
    );
  };

  useEffect(() => {
    getRetirementFields(moduleRetirement);
    getAnalysisFields(moduleBreakAnalysis);
    fetchAllRetirment();
  }, []);

  return (
    <div className="retirement-calculator-main">
      <div className="social-security-main-heading-container">
        <div className="social-security-icon-container">
          <img
            width={32}
            height={32}
            src={retirementIcon}
            alt={"Retirement Calculator"}
          ></img>
        </div>
        {/* {moduleData.name} */}
        <div className="social-security-main-heading">
          Retirement Earnings Test Calculator
          <ToolTipCreator name={"retirement_earnings_tooltip"} />
        </div>
      </div>
      <div className="social-security-calculator-content-main">
        <div className="social-security-calculator-content-form-container">
          <div className="social-security-sub-title">
            Complete these two items if you are currently working and are
            eligible for retirement benefits this year.
          </div>
          <div className="social-security-sub-heading">
            If you reach your full retirement age this year, enter only those
            earnings made prior to the month you reach this age. The retirement
            earnings test does not apply once you reach normal retirement age.
          </div>
          {/* <SocialSecurityHardCodeFields
            formFields={formFields && formFields}
            formData={formData && formData}
            onChange={handleChange}
          /> */}
          {loadingAttributesRetirement ? (
            <SocialSecurityFormSkeleton rows={1} />
          ) : (
            <div style={{ position: "relative" }}>
              <SocialSecurityFormFields
                formFields={retirementAttributes && retirementAttributes}
                formData={formData && formData}
                onChange={handleChange}
              />
              <NewLoader isLoading={loading} />
            </div>
          )}
          <button
            className="social-security-calculator-submit-button"
            onClick={(e) => {
              e.preventDefault();
              handleCalculate();
            }}
            disabled={loading || loadingAttributesRetirement || !formData}
          >
            Calculate
          </button>
        </div>
        <div className="social-security-calculator-results">
          <h3>Retirement Earnings Test Results</h3>
          <div className="social-security-result-tag-container">
            {resultArray &&
              resultArray.map((item, index) => (
                <div
                  key={index}
                  className="social-security-main-heading-container"
                >
                  <div className="social-security-result-icon-container">
                    <img
                      width={32}
                      height={32}
                      src={item.icon}
                      alt={item.name}
                    ></img>
                  </div>
                  <div className="social-security-results-main">
                    <div className="social-result-heading"> {item.name} </div>
                    <div className="social-result-value">
                      {" "}
                      {loading ? <NumberCardSkeleton /> : item.value}{" "}
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>

      <div className="retirement-calculator-main">
        <div className="social-security-main-heading-container">
          <div className="social-security-icon-container">
            <img
              width={32}
              height={32}
              src={compareIcon}
              alt={"Retirement Calculator"}
            ></img>
          </div>
          {/* {moduleData.name} */}
          <div className="social-security-main-heading">
            Break-even Analysis
            <ToolTipCreator name={"retirement_earnings_tooltip"} />
          </div>
        </div>
        <div className="social-security-calculator-content-main">
          <div className="social-security-calculator-content-form-container">
            {loadingAttributesAnalysis ? (
              <SocialSecurityFormSkeleton rows={1} />
            ) : (
              <SocialSecurityFormFields
                formFields={analysisAttributes && analysisAttributes}
                formData={analysisFormData && analysisFormData}
                onChange={handleAnalysisChange}
              />
            )}

            <button
              className="social-security-calculator-submit-button"
              onClick={(e) => {
                e.preventDefault();
                handleAnalysisCalculate();
              }}
              disabled={
                loading || loadingAttributesAnalysis || !analysisFormData
              }
            >
              Calculate
            </button>
          </div>
          <div className="social-security-calculator-results">
            <h3>Break-even Analysis Result</h3>
            <div
              className="social-security-result-tag-container"
              style={{ gap: "0.6rem" }}
            >
              <div className="social-security-main-heading-container">
                <div className="social-security-result-icon-container">
                  <img
                    width={32}
                    height={32}
                    src={timeIcon}
                    alt={timeIcon}
                  ></img>
                </div>
                <div className="social-security-results-main">
                  <div className="social-result-heading"> Breakeven Age </div>
                  <div className="social-result-value">
                    {" "}
                    {loading ? (
                      <NumberCardSkeleton />
                    ) : analysisResults &&
                      analysisResults.breakEvenAge &&
                      analysisResults.breakEvenAge.formatted ? (
                      analysisResults.breakEvenAge.formatted
                    ) : (
                      "N/A"
                    )}{" "}
                  </div>
                </div>
              </div>
              <div className="social-security-sub-desc">
                This is the age where waiting to claim results in a higher total
                lifetime benefit.
              </div>
              {analysisResultArray &&
                analysisResultArray.map((item, index) => (
                  <div
                    key={index}
                    className="social-security-main-heading-container"
                  >
                    <div className="social-security-result-icon-container">
                      <img
                        width={32}
                        height={32}
                        src={item.icon}
                        alt={item.name}
                      ></img>
                    </div>
                    <div className="social-security-results-main">
                      <div className="social-result-heading"> {item.name} </div>
                      <div className="social-result-value">
                        {" "}
                        {loading ? <NumberCardSkeleton /> : item.value}{" "}
                      </div>
                    </div>
                  </div>
                ))}
              <div className="social-security-sub-desc">
                Calculation based on a life expectancy of{" "}
                {(analysisFormData && analysisFormData["Life Expectancy"]) ||
                  83}{" "}
                years.
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="retirement-calculator-main">
        <div className="social-security-main-heading-container">
          <div className="social-security-icon-container">
            <img
              width={32}
              height={32}
              src={barIcon}
              alt={"Break-even Analysis"}
            ></img>
          </div>
          {/* {moduleData.name} */}
          <div className="social-security-main-heading">
            Break-even Analysis Visualization
            <ToolTipCreator name={"retirement_earnings_tooltip"} />
          </div>
        </div>
        <div
          className="social-security-calculator-content-main"
          style={{ position: "relative" }}
        >
          <div className="social-security-chart">
            <div className="social-security-chart-heading">
              Break-even Analysis
            </div>
            <div style={{ height: "300px", display: "flex", width: "100%" }}>
              <HorizontalBar options={options} data={barChartData} />
            </div>
            <div style={{ display: "flex", width: "100%", marginTop: "1rem" }}>
              <Line
                height={80}
                data={
                  analysisResults && analysisResults.chartData
                    ? analysisResults.chartData
                    : lineChartData
                }
                options={lineChartOptions}
              />
            </div>
          </div>
          <NewLoader isLoading={loading} />
        </div>
      </div>
    </div>
  );
};
